import Layout from '@/components/feature/Layout';

export default function PaymentPage() {
  return (
    <Layout>
      <div className="bg-primary-900 py-16 md:py-24">
        <div className="w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-400 mb-3">
            Pagos
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Pagar Servicio de Agua
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Realiza el pago de tu servicio de agua de forma virtual, rápida y segura. Sin filas, sin puntos físicos.
          </p>
        </div>
      </div>

      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            {/* QR Payment */}
            <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70 text-center">
              <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mx-auto mb-4">
                <i className="ri-qr-code-line text-accent-600 text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h2 className="font-heading font-semibold text-lg text-foreground-950 mb-2">
                Pago por QR
              </h2>
              <p className="text-sm text-foreground-600 mb-5">
                Escanea el código QR con tu billetera móvil para realizar tu pago de forma instantánea.
              </p>
              <div className="w-48 h-48 mx-auto rounded-xl overflow-hidden border border-background-200 mb-4">
                <img
                  src="https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/aaa91190-24aa-4551-849f-2433fab5f84b_compressed_QR-DE-CANCELACION.webp"
                  alt="Código QR para pago virtual CODESAJAN"
                  className="w-full h-full object-contain"
                />
              </div>
              <p className="text-xs text-foreground-500">CODESAJAN — Pago Virtual QR</p>
            </div>

            {/* Bank Transfer */}
            <div className="p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70">
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4">
                <i className="ri-bank-line text-primary-600 text-xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <h2 className="font-heading font-semibold text-lg text-foreground-950 mb-2">
                Transferencia Bancaria
              </h2>
              <p className="text-sm text-foreground-600 mb-5">
                Realiza una transferencia a nuestra cuenta y envía el comprobante por WhatsApp.
              </p>
              <div className="space-y-3 text-sm">
                <div className="flex justify-between py-2 border-b border-background-200/50">
                  <span className="text-foreground-500">Banco</span>
                  <span className="font-medium text-foreground-950">Banco Union S.A.</span>
                </div>
                <div className="flex justify-between py-2 border-b border-background-200/50">
                  <span className="text-foreground-500">Titular</span>
                  <span className="font-medium text-foreground-950">CODESAJAN</span>
                </div>
                <div className="flex justify-between py-2 border-b border-background-200/50">
                  <span className="text-foreground-500">Tipo</span>
                  <span className="font-medium text-foreground-950">Cuenta Corriente</span>
                </div>
              </div>
              <div className="mt-5 p-3 rounded-lg bg-accent-50 border border-accent-100">
                <p className="text-xs text-accent-700">
                  <i className="ri-whatsapp-line w-3.5 h-3.5 inline-flex items-center justify-center mr-1"></i>
                  Envía el comprobante por WhatsApp al <strong>+591 73455233</strong>
                </p>
              </div>
            </div>
          </div>

          {/* Virtual payment notice */}
          <div className="mt-8 p-6 md:p-8 rounded-xl bg-primary-50 border border-primary-100 text-center">
            <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center mx-auto mb-3">
              <i className="ri-smartphone-line text-primary-600 text-xl w-6 h-6 flex items-center justify-center"></i>
            </div>
            <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-2">
              100% Virtual
            </h3>
            <p className="text-sm text-foreground-600 max-w-lg mx-auto">
              CODESAJAN no cuenta con puntos de cobro físicos. Todos los pagos se realizan de manera virtual mediante QR o transferencia bancaria. Si tenés dudas, escribinos por WhatsApp.
            </p>
            <a
              href="https://wa.me/59173455233"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-4 px-5 py-2.5 bg-green-500 hover:bg-green-600 text-white font-medium rounded-lg transition-colors text-sm"
            >
              <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              Escribir por WhatsApp
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}